export default "__VITE_ASSET__BUTGiBK8__"